import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { ReferenceTableService } from '../reference-table.service';
import { NotificationsService } from 'angular2-notifications';
import { ServerConstantsService, CommonUtility, DataService } from '../shared';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {
  @ViewChild('emailField') emailField: ElementRef;
  serverConstants;
  username;
  userActionNotificationsMap;
  workerportal:Boolean = false;
  showFlag:Boolean;

  constructor(
    private router: Router,
    private http: HttpClient,
    private data: ReferenceTableService,
    private commonUtil: CommonUtility,
    private dataService: DataService,
    private notificationService: NotificationsService,
    private serverConstantsService: ServerConstantsService,
  ) {
    this.serverConstants = serverConstantsService.getConstants();
  }

  ngOnInit() {
    console.log(this.dataService.getSharedDataObject().get("ISWORKERPORTAL"));
    if(this.dataService.getSharedDataObject().get("ISWORKERPORTAL") === true){
      this.workerportal = true;
    }
    else{
      this.workerportal = false;
    }
    const userActionNotifications = this.data.getValueFromSharedDataMap('USER-ACTION-NOTIFICATIONS');
    this.userActionNotificationsMap = this.commonUtil.createNativeMapFromList(userActionNotifications);

  }
  restrict(event) {
    if (event.key !== '.' && event.key !== '@') {
      return true;
    }
    else {
      return false;
    }
  }
  Workersave() {
    if (this.username.indexOf('@') > -1 || this.username.indexOf('.') > -1) {

      this.showFlag = true;
    } else {
      this.showFlag = false;
      if (this.username !== undefined && this.username !== '') {
        this.http.post<any>(this.serverConstants.SERVER_API_URL + '/user/forgot', this.username)
          .subscribe(
            (res) => {
              if (res.hasOwnProperty('errorCode')) {

                this.notificationService.error('Forgot Password',  this.userActionNotificationsMap.ERROR);
              } else {
                if (res.status === 'Success') {
                  this.notificationService.success('Forgot Password', 'Temporary password successfully sent to your email address');
                  this.router.navigate(['SNAPWorks/workerportal']);

                } else {
                  this.notificationService.error('Forgot Password', 'Username does not exist in Snapworks and contact Admin.');
                }

              }
            },

            (response) => {
              this.notificationService.error('Forgot Password', this.userActionNotificationsMap.ERROR);
            },
            () => {
            });
      }
    }
  }
  save() {
    this.validateEmail();
    // Remove login error message
    if(this.showFlag == false){
      this.showFlag = false;
      if (this.username !== undefined && this.username !== '') {
        this.http.post<any>(this.serverConstants.SERVER_API_URL + '/user/forgot', this.username)
          .subscribe(
            (res) => {
              if (res.hasOwnProperty('errorCode')) {

                this.notificationService.error('Forgot Password',  this.userActionNotificationsMap.ERROR);
              } else {
                if (res.status === 'Success') {
                  this.notificationService.success('Forgot Password', 'Temporary password successfully sent to your email address');
                  this.router.navigate(['SNAPWorks/providerportal']);

                } else {
                  this.notificationService.error('Forgot Password', 'Username does not exist in Snapworks and contact Admin.');
                }

              }
            },

            (response) => {
              this.notificationService.error('Forgot Password', this.userActionNotificationsMap.ERROR);
            },
            () => {
            });
      }
    }
  }
  validateEmail() {
   
    const regExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if (this.username !== null && this.username !== undefined) {
      if (!regExp.test(String(this.username).toLowerCase())) {
        this.showFlag = true;
        this.emailField.nativeElement.classList.remove('ng-valid');
        this.emailField.nativeElement.classList.add('ng-invalid');
        return false;
      } else {
        this.showFlag = false;
        this.emailField.nativeElement.classList.remove('ng-invalid');
        this.emailField.nativeElement.classList.add('ng-valid');
        /*this.emailMsg.nativeElement.classList.remove('d-block');
        this.emailMsg.nativeElement.classList.add('d-none');*/
        return true;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/forgot-password/forgot-password.component.ts